import script from "./diamond360Defaults.vue?vue&type=script&setup=true&lang=ts"
export * from "./diamond360Defaults.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__